import { Link } from "react-router-dom";
import { Heart, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import DonationProgress from "@/components/DonationProgress";
import CaseImage from "@/components/CaseImage";
import { getCasePhotoUrls } from "@/lib/api";
import { daysUnderCareLabel } from "@/lib/dateUtils";

export default function PublicCaseCard({ caseItem }) {
  const cover = getCasePhotoUrls(caseItem)[0];
  const story = caseItem.public_story || caseItem.case_history;
  const hasDonationGoal = (caseItem.donation_needed || 0) > 0;

  return (
    <div
      data-testid={`public-case-card-${caseItem.slug}`}
      className="bg-amtm-surface border border-amtm-border rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:scale-[1.02] flex flex-col"
    >
      <Link to={`/case/${caseItem.slug}`} className="block h-56 w-full overflow-hidden bg-amtm-give/30">
        <CaseImage src={cover} alt={caseItem.animal_name} animalType={caseItem.animal_type} className="w-full h-full object-cover" />
      </Link>
      <div className="p-5 flex flex-col gap-3 flex-1">
        <div>
          <h3 className="font-display text-2xl text-amtm-text">{caseItem.animal_name}</h3>
          <p className="text-sm text-amtm-textMuted mt-1 line-clamp-2">{story}</p>
        </div>
        <p className="text-xs text-amtm-textMuted flex items-center gap-1">
          <Clock className="h-3 w-3" /> {daysUnderCareLabel(caseItem)}
        </p>
        {hasDonationGoal && (
          <DonationProgress
            needed={caseItem.donation_needed}
            received={caseItem.donation_received_total ?? caseItem.donation_received}
            donorCount={caseItem.donor_count}
            testId={`public-case-donation-${caseItem.slug}`}
          />
        )}
        <Button asChild className="w-full rounded-full bg-amtm-give text-amtm-giveText hover:bg-amtm-giveHover mt-1" data-testid={`help-button-${caseItem.slug}`}>
          <Link to={`/case/${caseItem.slug}`}>
            <Heart className="h-4 w-4 mr-1.5" /> Help {caseItem.animal_name}
          </Link>
        </Button>
      </div>
    </div>
  );
}

